// Typed localStorage wrapper
// All localStorage access should go through this module

const isAvailable = typeof window !== "undefined" && typeof localStorage !== "undefined";

const storage = {
  get(key, fallback = null) {
    if (!isAvailable) return fallback;
    try {
      const value = localStorage.getItem(key);
      if (value === null) return fallback;
      return JSON.parse(value);
    } catch {
      // Value is not JSON, return as string
      return localStorage.getItem(key) || fallback;
    }
  },

  getString(key, fallback = "") {
    if (!isAvailable) return fallback;
    return localStorage.getItem(key) || fallback;
  },

  set(key, value) {
    if (!isAvailable) return;
    try {
      const serialized = typeof value === "string" ? value : JSON.stringify(value);
      localStorage.setItem(key, serialized);
    } catch (error) {
      console.error(`[storage] Failed to set "${key}":`, error);
    }
  },

  remove(key) {
    if (!isAvailable) return;
    localStorage.removeItem(key);
  },

  clear() {
    if (!isAvailable) return;
    localStorage.clear();
  },

  has(key) {
    if (!isAvailable) return false;
    return localStorage.getItem(key) !== null;
  },
};

export default storage;
